<div class="page-number">
    <pagination (pageChanged)="pageChanged($event)" [totalItems]="totalItems"previousText="&lsaquo;" 
    [maxSize]="maxSize" [itemsPerPage]="pageSize" nextText="&rsaquo;"></pagination>
</div>